import React from "react";
import Unauthorized from "../components/utils/Unauthorized";

const UnauthorizedPage = () => {
  return <Unauthorized />;
};

export default UnauthorizedPage;
